import { gql } from "@apollo/client";
import {
  GET_EMPLOYEE,
  GET_EMPLOYEE_ONLY,
  GET_MEDICAL,
  GET_VISA,
} from "../fragments/processes";

export const GET_ALL_EMPLOYEES = gql`
  ${GET_EMPLOYEE}
  query GetEmployees(
    $searchText: String
    $status: EmployeeStatus
    $skip: Int!
    $take: Int!
    $link: String
    $prospectId: String
  ) {
    employees(
      skip: $skip
      take: $take
      searchText: $searchText
      status: $status
      link: $link
      prospectId: $prospectId
    ) {
      totalCount
      employees {
        ...getEmployee
      }
    }
  }
`;
export const GET_SHARED_EMPLOYEES = gql`
  ${GET_EMPLOYEE_ONLY}
  query GetSharedEmployees($link: String) {
    sharedEmployees(link: $link) {
      totalCount
      employees {
        ...getEmployeeOnly
      }
    }
  }
`;
export const GET_LINKED_EMPLOYEES = gql`
  ${GET_EMPLOYEE_ONLY}
  query GetLinkedEmployees(
    $agencyId: String
    $agentId: String
    $status: EmployeeStatus
  ) {
    linkedEmployees(agencyId: $agencyId, agentId: $agentId, status: $status) {
      totalCount
      employees {
        ...getEmployeeOnly
      }
    }
  }
`;
export const GET_ALL_SHORT_LINKS = gql`
  query GetShortLinks {
    shortLinks {
      _id
      link

      employees {
        _id
        givenName
      }
    }
  }
`;

export const GET_SELECTED_EMPLOYEE = gql`
  ${GET_EMPLOYEE}
  query GetSelectedEmployee($id: String!) {
    getEmployee(input: { _id: $id }) {
      ...getEmployee
    }
  }
`;

export const GET_ALL_VISAS = gql`
  ${GET_VISA}
  query GetVisas($searchText: String, $skip: Int!, $take: Int!) {
    visas(skip: $skip, take: $take, searchText: $searchText) {
      totalCount
      visas {
        ...getVisa
      }
    }
  }
`;

export const GET_SELECTED_VISA = gql`
  ${GET_VISA}
  query GetSelectedVisa($id: String!) {
    getVisa(input: { _id: $id }) {
      ...getVisa
    }
  }
`;

export const GET_ALL_MEDICALS = gql`
  ${GET_MEDICAL}
  query GetMedicalPayments($searchText: String, $skip: Int!, $take: Int!) {
    visas(skip: $skip, take: $take, searchText: $searchText) {
      totalCount
      visas {
        ...getMedicalPayment
      }
    }
  }
`;

export const GET_SELECTED_MEDICAL = gql`
  ${GET_MEDICAL}
  query GetSelectedMedicalPayment($id: String!) {
    getMedicalPayment(input: { _id: $id }) {
      ...getMedicalPayment
    }
  }
`;

export const CHECK_STATUS_CAPTCHA = gql`
  ${GET_EMPLOYEE}
  query recaptchaCheckStatus($searchText: String, $captcha: String) {
    recaptchaCheckStatus(
      input: { searchText: $searchText, captcha: $captcha }
    ) {
      ...getEmployee
    }
  }
`;
